import { MediaTimeDisplay, MediaTimeRange } from 'media-chrome/react';

import { Typography } from '@/components/atoms/Typography';
import { Duration, durationToTimecode } from '@/lib/utils/time-formatting';

import { defaultRangeStyling } from './util';

interface Props {
  mode?: 'row' | 'column';
  duration: Duration;
  mediaController?: string;
  onMouseDown?: () => void;
  onMouseUp?: () => void;
}

export function PlayerScrubber({
  duration,
  mediaController,
  onMouseDown = () => {},
  onMouseUp = () => {},
}: Props) {
  const durationDisplay = durationToTimecode(duration);

  return (
    <div className="w-full flex flex-col">
      <div className="flex">
        <MediaTimeRange
          className="grow bg-transparent -m-2"
          style={defaultRangeStyling}
          onMouseDown={onMouseDown}
          onMouseUp={onMouseUp}
          // @ts-expect-error - media-chrome types doesn't export this but it exists
          mediaController={mediaController}
        >
          <span slot="preview"></span>
        </MediaTimeRange>
      </div>
      <div className="flex justify-between mt-2">
        <MediaTimeDisplay
          className="bg-transparent text-xs text-(--player-text-color-primary)"
          // @ts-expect-error - media-chrome types doesn't export this but it exists
          mediaController={mediaController}
        />
        <Typography.Text variant="paragraph" className="text-xs">
          {durationDisplay}
        </Typography.Text>
      </div>
    </div>
  );
}
